export default "__VITE_ASSET__3aca0c6c__"